export const GLOBAL_ERROR = "오류가 발생했습니다.";
